/*
 * File: asana.service.ts
 * Project: a-a
 * File Created: Thursday, 24th April 2025 12:57:51 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 21st August 2025 10:30:26 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import axios from '../core/axios';

import { ApiConstants } from './api-constants';
export class AsanaService {
  static asanaExchangeToken = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_LOGIN.URL(), payload)
    ).data;
  };
  static asanaLogout = async (payload: any, header?: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_LOGOUT.URL(), payload, { headers: header })
    ).data;
  };
  static asanaValidateToken = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_VALIDATE_TOKEN.URL(), payload)
    ).data;
  };
  static asanaRefreshToken = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_REFRESH.URL(), payload)
    ).data;
  };
  static getAsanaStats = async () => {
    return await (
      await axios.get(ApiConstants.ASANA_API.STATISTICS.URL())
    ).data;
  };
  static getAsanaTeams = async () => {
    return await (
      await axios.get(ApiConstants.ASANA_API.TEAMS.URL())
    ).data;
  };
  static getAsanaProject = async (query?: any) => {
    return await (
      await axios.get(
        ApiConstants.ASANA_API.PROJECTS.URL() + ApiConstants.ASANA_API.PROJECTS.QUERY_PARAMS(query),
      )
    ).data;
  };
  static createAsanaProject = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.CREATE_PROJECT.URL(), payload)
    ).data;
  };
  static editAsanaProject = async (id: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.ASANA_API.EDIT_PROJECT.URL(id), payload)
    ).data;
  };
  static deleteAsanaProject = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.ASANA_API.DELETE_PROJECT.URL(id))
    ).data;
  };
  static getAsanaTasksBySection = async (id: string, query?: any) => {
    return await (
      await axios.get(
        ApiConstants.ASANA_API.TASKS_BY_SECTION.URL(id) +
          ApiConstants.ASANA_API.TASKS_BY_SECTION.QUERY_PARAMS(query),
      )
    ).data;
  };
  static getAsanaFilter = async () => {
    return await (
      await axios.get(ApiConstants.ASANA_API.FILTER_OPTIONS.URL())
    ).data;
  };
  static moveTask = async (id: string, payload: { taskId: string }) => {
    return await (
      await axios.patch(ApiConstants.ASANA_API.MOVE_BY_SECTION.URL(id), payload)
    ).data;
  };
  static taskFilterOption = async (id: string) => {
    return await (
      await axios.get(ApiConstants.ASANA_API.TASK_FILTER.URL(id))
    ).data;
  };
  static createAsanaTask = async (id: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.CREATE_TASKS.URL(id), payload)
    ).data;
  };
  static editAsanaTask = async (id: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.ASANA_API.EDIT_DELETE_TASKS.URL(id), payload)
    ).data;
  };
  static deleteAsanaTask = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.ASANA_API.EDIT_DELETE_TASKS.URL(id))
    ).data;
  };
  static addAsanaAttachments = async (id: string, file: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_TASK_ATTACHMENTS.URL(id), file, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important to set this header
        },
      })
    ).data;
  };
  static inviteMembers = async (id: string, member: string) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_INVITE_MEMBERS.URL(id), {
        emails: member,
        // project_id: id,
      })
    ).data;
  };
  static deleteAsanaAttachments = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.ASANA_API.ASANA_ATTACHMENTS_REMOVE.URL(id))
    ).data;
  };

  static getAsanaTasksById = async (id: string, query?: any) => {
    return await (
      await axios.get(
        ApiConstants.ASANA_API.ASANA_TASK_BY_ID.URL(id) +
          ApiConstants.ASANA_API.TASKS_BY_SECTION.QUERY_PARAMS(query),
      )
    ).data;
  };
  static createAsanaSection = async (id: string, payload: any) => {
    return await (
      await axios.post(ApiConstants.ASANA_API.ASANA_ADD_SECTION.URL(id), payload)
    ).data;
  };
  static editAsanaSection = async (id: string, payload: any) => {
    return await (
      await axios.patch(ApiConstants.ASANA_API.ASANA_EDIT_DELETE_SECTION.URL(id), payload)
    ).data;
  };
  static deleteAsanaSection = async (id: string) => {
    return await (
      await axios.delete(ApiConstants.ASANA_API.ASANA_EDIT_DELETE_SECTION.URL(id))
    ).data;
  };
}
